import Lenis from 'lenis';

let instance = null;

export function initLenis() {
  if (instance) return instance;
  instance = new Lenis({
    duration: 1.1,
    easing: (t) => 1 - Math.pow(1 - t, 3),
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 1.5,
  });
  return instance;
}

export function destroyLenis() {
  if (instance) {
    instance.destroy();
    instance = null;
  }
}

export function getLenis() {
  return instance;
}
